<p *ngIf="mostrarCountdown" [ngClass]="labelClass ? labelClass : ''"  class="overflow-text-cover-2">
  <!-- Quedan {{ dias }} días, {{ horas }} hrs, {{ minutos }} min y {{ segundos }} s para completar tu curso -->

   <!-- Caso 1: Hay días restantes -->
   <span *ngIf="dias !== '00'">
    Quedan {{ dias }} día(s), {{ horas }} h, {{ minutos }} min y {{ segundos }} s para completar tu curso
  </span>

  <!-- Caso 2: No hay días pero sí horas -->
  <span *ngIf="dias === '00' && horas !== '00'">
    Quedan {{ horas }} h,
    {{ minutos }} min y {{ segundos }} s para completar tu curso
  </span>

  <!-- Caso 3: No hay días ni horas (siempre muestra minutos y segundos) -->
  <span *ngIf="dias === '00' && horas === '00'">
    Quedan {{ minutos }} min y {{ segundos }} s para completar tu curso
  </span>
</p>

<p *ngIf="!mostrarCountdown" [ngClass]="labelClass ? labelClass : ''" class="flex items-center">
  <mat-icon *ngIf="displayTimeIcon" class="mdi text-base leading-4  mr-2.5 "
  [ngClass]="{'mdi-clock-time-four text-white' : true, 'mdi-alert warning-icon': false, 'hidden': displayCourseAvailability && i ===  selectedAvailabilityChipIndex}"
  ></mat-icon>
  {{scheduledMsg}}
</p>
